<script>
import { mapState } from 'vuex'
import { createVerification, createVerificationToken } from '@apis/mail'

export default {
  page: {
    title: 'Mypage::MailVerification',
    meta: [{ name: 'description', content: 'Mypage::MailVerification' }],
  },
  data() {
    return {
      token: null,
      auth_code: '',
      token_info: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('auth', ['currentUser']),
  },
  methods: {
    handleCreateToken() {
      this.loading = true
      createVerificationToken()
        .then(({ token }) => {
          this.token = token
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('toasted_msg.email_auth_send'),
            type: 'success',
          })
          this.token_info = this.$jwt.decode(this.token)
        })
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    handleCreate() {
      this.loading = true
      createVerification(this.$data)
        .then(({ token }) => {
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('toasted_msg.email_auth'),
            type: 'success',
          })
          this.$router.push({ name: 'myprofile' })
        })
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    resetVerify() {
      this.token = null
      this.token_info = null
    },
  },
}
</script>

<template>
  <div class="foreground-container">
    <div class="container">
      <div class="wrap-md">
        <div class="big-title-wrap center">
          <h2 class="big-title">{{ $t('my_page.email_auth') }}</h2>
          <img src="@assets/images/v2/img-auth.png" alt="" class="pc" />
          <img src="@assets/images/v2/img-auth-m.png" alt="" class="mobile" />
        </div>
        <div v-loading="loading" class="verify-wrap">
          <div :class="[$style.mailVerifyWrap]">
            <div class="form-group email-form">
              <label>{{ $t('my_page.email_address') }}</label>
              <div :class="[$style.emailInfoWrap]">
                <div class="input-btn-wrap">
                  <el-input
                    :class="[$style.emailInfo]"
                    :value="currentUser.email_address"
                    disabled
                  >
                    {{}}
                  </el-input>
                  <div class="btn-wrap">
                    <button
                      v-if="token"
                      class="btn btn-primary"
                      @click.prevent="handleCreate"
                    >
                      {{ $t('kyc.auth') }}
                    </button>
                    <button
                      v-else
                      class="btn btn-primary"
                      @click.prevent="handleCreateToken"
                    >
                      {{ $t('kyc.auth_code_send') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="token" class="form-group">
              <div :class="[$style.requiredImg]">*</div>
              <label>{{ $t('kyc.auth_code') }}</label>
              <div class="remi-colorized-field">
                <div class="input-btn-wrap">
                  <el-input v-model="auth_code">
                    <template slot="append">
                      <vue-countdown-timer
                        style="display:inline-block;"
                        :start-time="token_info.iat"
                        :end-time="token_info.exp"
                        @end_callback="resetVerify"
                      >
                        <template slot="countdown" slot-scope="scope"
                          ><span>{{ scope.props.minutes }}</span
                          ><i>{{ scope.props.minutesTxt }}</i>
                          <span>{{ scope.props.seconds }}</span></template
                        >
                      </vue-countdown-timer>
                    </template>
                  </el-input>
                  <div :class="[$style.explanationWrap]">
                    <span :class="[$style.explanation, 'mobile']">{{
                      $t('kyc.msg_auth_code')
                    }}</span>
                  </div>
                  <div class="btn-wrap">
                    <button class="btn" @click.prevent="handleCreate">
                      {{ $t('kyc.auth_confirm_code') }}
                    </button>
                  </div>
                </div>
              </div>

              <div :class="[$style.explanationWrap]">
                <span :class="[$style.explanation, 'pc']">{{
                  $t('kyc.msg_auth_code')
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
@import '@src/design/mail.scss';
</style>
